import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '../store/auth'
import DefaultLayout from '../layouts/DefaultLayout.vue'
import LoginView from '../views/LoginView.vue'
import DashboardView from '../views/DashboardView.vue'
import OrdersView from '../views/OrdersView.vue'
import ApiKeysView from '../views/ApiKeysView.vue'
import WebhooksView from '../views/WebhooksView.vue'
import DocsView from '../views/DocsView.vue'
import SettingsView from '../views/SettingsView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
  },
  {
    path: '/',
    component: DefaultLayout,
    meta: { requiresAuth: true },
    children: [
      { path: '', redirect: '/dashboard' },
      { path: 'dashboard', name: 'dashboard', component: DashboardView },
      { path: 'orders', name: 'orders', component: OrdersView },
      { path: 'api-keys', name: 'api-keys', component: ApiKeysView },
      { path: 'webhooks', name: 'webhooks', component: WebhooksView },
      { path: 'docs', name: 'docs', component: DocsView },
      { path: 'settings', name: 'settings', component: SettingsView },
    ],
  },
  { path: '/:pathMatch(.*)*', redirect: '/dashboard' },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()

  if (to.meta.requiresAuth) {
    if (!authStore.isAuthenticated && !authStore.isLoading) {
      const ok = await authStore.checkAuth()
      if (!ok) return next('/login')
    }
    // Seul le propriétaire gère l'équipe et la facturation, mais la page
    // Paramètres reste consultable par tous (sections en lecture seule).
    return next()
  }

  next()
})

export default router
